import { ActiveModel, ActiveField } from '@alt-point/active-models/src'
import { SDEKOfficeType, SDEKLang } from './Enums'
/**
* Class CdekOfficesRequestQuery
*  Query params for operation "CdekOffices"
*/
export class CdekOfficesRequestQuery extends ActiveModel {

/**
  * Code
  * Код ПВЗ<br>
  */
  @ActiveField()
  Code?: string


  /**
  * Type
  * Тип офиса. По умолчанию (если не указан) - все офисы (любого типа)<br>  */
  @ActiveField()
  Type?: SDEKOfficeType


/**
  * PostalCode
  * Почтовый индекс города, для которого необходим список офисов<br>
  */
  @ActiveField()
  PostalCode?: string


  /**
  * CityCode
  * Код населенного пункта СДЭК<br>(метод [Список населенных пунктов](https://apidoc.cdek.ru/#tag/location/operation/cities)M:Infrastructure.SDEK.SDEKClient.Cities(Infrastructure.SDEK.Dto.SDEKCityRequest,Infrastructure.SDEK.SDEKClientCredentials,System.Threading.CancellationToken))<br>  */
  @ActiveField()
  CityCode?: number


/**
  * CountryCode
  * Код страны в формате ISO_3166-1_alpha-2<br>([см. “Общероссийский классификатор стран мира”](https://esnsi.test.gosuslugi.ru/classifiers/12824/data))<br>
  */
  @ActiveField()
  CountryCode?: string


  /**
  * RegionCode
  * Код региона ([справочник СДЭК](https://apidoc.cdek.ru/#tag/location/operation/regions))<br>  */
  @ActiveField()
  RegionCode?: number


  /**
  * HaveCashless
  * Наличие терминала оплаты<br>  */
  @ActiveField()
  HaveCashless?: boolean


  /**
  * HaveCash
  * Есть прием наличных<br>  */
  @ActiveField()
  HaveCash?: boolean


  /**
  * AllowedCod
  * Разрешен наложенный платеж<br>  */
  @ActiveField()
  AllowedCod?: boolean


  /**
  * IsDressingRoom
  * Наличие примерочной<br>  */
  @ActiveField()
  IsDressingRoom?: boolean


  /**
  * WeightMax
  * Максимальный вес в кг, который может принять офис: <br><br>значения больше 0 - передаются офисы, которые принимают этот вес; <br><br>0 - офисы с нулевым весом не передаются; <br><br>значение не указано - все офисы<br>  */
  @ActiveField()
  WeightMax?: number


  /**
  * WeightMin
  * Минимальный вес в кг, который принимает офис (при переданном значении будут выводиться офисы с минимальным весом до указанного значения)<br>  */
  @ActiveField()
  WeightMin?: number


  /**
  * Lang
  * Локализация офиса. По умолчанию Infrastructure.SDEK.Dto.Enums.SDEKLang.Rus  */
  @ActiveField()
  Lang?: SDEKLang


  /**
  * TakeOnly
  * Является ли офис только пунктом выдачи<br>  */
  @ActiveField()
  TakeOnly?: boolean


  /**
  * IsHandout
  * Является пунктом выдачи<br>  */
  @ActiveField()
  IsHandout?: boolean


  /**
  * IsReception
  * Есть ли в офисе приём заказов<br>  */
  @ActiveField()
  IsReception?: boolean


  /**
  * IsMarketplace
  * Офис для доставки "До маркетплейса"<br>  */
  @ActiveField()
  IsMarketplace?: boolean


  /**
  * IsLtl
  * Работает ли офис с LTL (сборный груз)<br>  */
  @ActiveField()
  IsLtl?: boolean


  /**
  * LtlAcceptancePartners
  * Принимает заказы LTL, которые будут доставляться партнерами<br>  */
  @ActiveField()
  LtlAcceptancePartners?: boolean


  /**
  * LtlIssuancePartners
  * Выдает заказы LTL, которые были доставлены партнерами<br>  */
  @ActiveField()
  LtlIssuancePartners?: boolean


  /**
  * Fulfillment
  * Офис с зоной фулфилмента<br>  */
  @ActiveField()
  Fulfillment?: boolean


/**
  * FiasGuid
  * Код города ФИАС<br>
  */
  @ActiveField()
  FiasGuid?: string


  /**
  * Size
  * Ограничение выборки результата (размер страницы)<br>  */
  @ActiveField()
  Size?: number


  /**
  * Page
  * Номер страницы выборки результата<br>  */
  @ActiveField()
  Page?: number
}
